import Vue from "vue";
import Router from "vue-router";
import { store } from "../_store";

// pages
// pagehome
import pageHome from "@/views/home/pageHome.vue";

// pages show CRUD {project, reports, images}
import pagesReports from "@/views/page-reports/pages.vue";
import pagesMedias from "@/views/page-medias/pages-medias.vue";
import pagesFolders from "@/views/page-directories/page-all-projects.vue";
import pageFolder from "@/views/page-directories/page.vue";
import pageNewProject from "@/views/projects/page-new-project.vue";
import pageUser from "@/views/user/user.vue";
import preview from "@/views/preview/preview.vue";
import pageAoi from "@/views/page-reports-aoi/page-aoi.vue";

// login
import loginPage from "@/views/login/login";
import resetPage from "@/views/login/reset";
import resetConfirmationPage from "@/views/login/newPassword";

import pageProfil from "@/views/pageProfile";
Vue.use(Router);

// start-guards
/**
 * If I don't identified, i go to /login else i go to the next route.
 * @param {I don't use} to variable content origin path for routes
 * @param {I don't use} from variable content from path for routes
 * @param {route go /home} next destination route
 */
const ifNotAuthentificated = (to, from, next) => {
  if (!store.getters["authentication/isAuthentificated"]) {
    next();
    return;
  }
  next("/home");
};

/**
 * If I'm identified, i go to /home else i go to the next route /login.
 * @param {I don't use} to variable content origin path for routes
 * @param {I don't use} from variable content from path for routes
 * @param {route go /home} next destination route
 */
const ifAuthentificated = (to, from, next) => {
  if (store.getters["authentication/isAuthentificated"]) {
    next();
    return;
  }
  next("/login");
};
// end-guards

/**
 * Table with routes and params for the routes of this app.
 */
export const router = new Router({
  mode: "history",
  routes: [
    {
      name: "profile",
      path: "/profile",
      component: pageProfil,
      beforeEnter: ifAuthentificated
    },
    {
      name: "home",
      path: "/home",
      component: pageHome,
      beforeEnter: ifAuthentificated
    },
    {
      name: "user",
      path: "/user",
      component: pageUser,
      beforeEnter: ifAuthentificated
    },
    {
      name: "login",
      path: "/login",
      component: loginPage,
      beforeEnter: ifNotAuthentificated
    },
    {
      name: "reset",
      path: "/reset",
      component: resetPage,
      beforeEnter: ifNotAuthentificated
    },
    {
      name: "newpassword",
      path: "/newpassword",
      component: resetConfirmationPage,
      beforeEnter: ifNotAuthentificated
    },
    {
      name: "projectsimple",
      path: "/projects/:uuid",
      component: pageFolder,
      // params: "",
      beforeEnter: ifAuthentificated
    },
    {
      name: "projects",
      path: "/projects",
      component: pagesFolders,
      beforeEnter: ifAuthentificated
    },
    {
      name: "newproject",
      path: "/newproject",
      component: pageNewProject,
      beforeEnter: ifAuthentificated
    },
    {
      name: "aoi",
      path: "/aoi-analyze",
      component: pageAoi,
      beforeEnter: ifAuthentificated
    },
    {
      name: "medias",
      path: "/medias",
      component: pagesMedias,
      params: "",
      beforeEnter: ifAuthentificated
    },
    {
      name: "reports",
      path: "/reports",
      component: pagesReports,
      params: "",
      beforeEnter: ifAuthentificated
    },
    // {
    //   name: "aoireports",
    //   path: "/reports-aoi/",
    //   component: pagesAOIReports,
    //   beforeEnter: ifAuthentificated
    // },
    {
      name: "preview",
      path: "/preview/",
      component: preview,
      beforeEnter: ifAuthentificated
    },
    // {
    //   name: "aoireport",
    //   path: "/reports/aoi/:uuid",
    //   component: pageAOIReport,
    //   beforeEnter: ifAuthentificated,

    // },
    { path: "*", redirect: "/login" }
  ]
});
